<template>
    <ssv-order-header-certification/>
</template>

<script>
    import SsvOrderHeaderCertification from './HeaderCertification';

    export default {
        name:       'SsvOrderHeaderDrywallCertification',
        components: { SsvOrderHeaderCertification },
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/header/HeaderDrywallNewTrends.vue